export default {
  login: {
    title: 'Welcome to Bioflux Trading!',
    form: {
      usernameLabel: 'Username',
      passwordLabel: 'Password',
      forgotPassword: 'Forgot password?',
      createAccount: 'Create account',
      loginButton: 'Login',
      signInWithMoeveEmployee: 'Sign in with Moeve employee account',
      contactSupport: 'If you have problems logging in, please contact support: biofluxtrading@moeveglobal.com',
    },
    forgotPassword: {
      title: 'Reset password',
      form: {
        usernameLabel: 'Username',
        codeLabel: 'Code',
        newPasswordLabel: 'New password',
        confirmPasswordLabel: 'Confirm password',
        setNewPasswordButton: 'Set new password',
        backButton: 'Back',
      },
    },
  },
  createAccount: {
    title: 'Create account',
    form: {
      companyNameLabel: 'Company name',
      adminNameLabel: 'Company manager name',
      adminEmailLabel: 'Company manager email',
      cupsLabel: 'Cups',
      cupsAliasLabel: 'Alias',
      consumerLabel: 'Consumer',
      producerLabel: 'Producer',
      createAccountButton: 'Create account',
      backButton: 'Back',
    },
  },
  newPassword: {
    title: 'New password required',
    form: {
      passwordLabel: 'Password',
      confirmPasswordLabel: 'Confirm password',
      setNewPasswordButton: 'Set new password',
      backButton: 'Back',
    },
  },
  home: {
    consumerCard: {
      title: 'Gas Consumer',
      description: 'Manage your gas consumption and compare it with Enagas data',
    },
    producerCard: {
      title: 'Biomethane Producer',
      description: 'Manage your biomethane production and compare it with Enagas data',
    },
    settingsCard: {
      title: 'Settings',
      description: 'Manage the configuration of your company, like cups and users',
    },
    sidebar: {
      home: 'Home',
      gasConsumer: 'Gas Consumer',
      settings: 'Settings',
    },
    logout: 'Logout',
    language: 'Change language',
    reportIssue: 'Report issue',
  },
  settings: {
    moeveActionsTab: {
      title: 'Moeve actions',
      pendingActions: {
        title: 'Pending actions',
        emptyMessage: 'No pending actions',
        types: {
          createCompany: 'Create company',
          createCups: 'Create cups',
          createMoeveUser: 'Create Moeve user',
        },
        columns: {
          type: 'Type',
          company: 'Company',
          action: 'Action',
        },
      },
      activeCompanies: {
        title: 'Active companies',
        emptyMessage: 'No active companies',
        columns: {
          company: 'Company',
          cups: 'Cups',
          alias: 'Alias',
          associatedTo: 'Associated to',
          consumer: 'Consumer',
          producer: 'Producer',
        },
      },
      moeveUserModal: {
        title: 'Please select a role and a company if needed',
        roleLabel: 'Role',
        companyLabel: 'Company',
        submitButton: 'Submit',
        errorRole: 'Role is required',
        errorCompany: 'Company is required for non-admin users',
      },
    },
    companyDetailsTab: {
      title: 'Company details',
      company: 'Company',
      noCompanySelectedMessage: 'No company selected, please select a company to see the details',
      companyCups: {
        title: 'Company Cups',
        addCupsButton: 'Add Cups',
        emptyMessage: 'No Cups to show',
        columns: {
          cups: 'Cups',
          alias: 'Alias',
          users: 'Users',
          status: 'Status',
        },
        modal: {
          createCupsTitle: 'Create Cups',
          updateCupsTitle: 'Update Cups',
          identifierLabel: 'Identifier',
          aliasLabel: 'Alias',
          usersLabel: 'Users',
          createCupsButton: 'Create',
          updateCupsButton: 'Update',
        },
      },
      companyUsers: {
        title: 'Company Users',
        addUsersButton: 'Add Users',
        emptyMessage: 'No users to show',
        columns: {
          name: 'Name',
          email: 'Email',
          associatedTo: 'Associated to',
          role: 'Role',
        },
        modal: {
          createUsersTitle: 'Create User',
          updateUsersTitle: 'Update User',
          nameLabel: 'Name',
          emailLabel: 'Email',
          managerLabel: 'Manager',
          userLabel: 'User',
          associatedCupsLabel: 'Associated Cups',
          createUsersButton: 'Create',
          updateUsersButton: 'Update',
        },
      },
    },
  },
  consumer: {
    filters: {
      dateRangeLabel: 'Date range',
      companyLabel: 'Company',
      cupsLabel: 'Cups - Alias',
      pleaseSelectCompanyFirst: 'Please select a company first',
    },
    buttons: {
      applyLabel: 'Apply',
      exportLabel: 'Export',
    },
    noFiltersPanel: {
      noFiltersMessage: 'Please select filters to display data',
      instructionMessage: "Select the filters and press 'Apply' to visualize the information",
    },
    tablePanel: {
      averages: {
        nomination: 'Nomination Average',
        enagas: 'Enagas Average',
      },
      columns: {
        date: 'Date',
        nomination: 'Nomination (kWh)',
        enagas: 'Enagas',
        difference: 'Difference',
        cups: 'Cups - Alias',
      },
      tooltip: {
        updatedBy: 'Updated by',
        pleaseInsertValueInKwh: 'Please insert a value in kWh',
      },
    },
    chartPanel: {
      yLabel: 'Volume (kWh)',
      averages: {
        nomination: 'Nomination Average',
        enagas: 'Enagas Average',
      },
    },
  },
  services: {
    updateConsumptions: {
      sucessTitle: 'Consumptions updated successfully',
      successMessage: '{{count}} consumption(s) have been updated successfully',
    },
    getConsumptions: {
      warning: 'Warning',
      message: 'No data for the selected date range',
    },
    activeCompanies: {
      companyTypeChanged: 'Company type changed successfully',
      companyDeleted: 'Company deleted successfully',
    },
    companyDetails: {
      createCupsSuccess: 'Cups created successfully',
      updateCupsSuccess: 'Cups updated successfully',
      deleteCupsSuccess: 'Cups deleted successfully',
      createUserSuccess: 'User created successfully',
      updateUserSuccess: 'User updated successfully',
      deleteUserSuccess: 'User deleted successfully',
      deleteCurrentUserError: 'You cannot delete the user you are currently logged in with',
    },
    pendingActions: {
      actionStatusChanged: 'Action status changed successfully',
    },
    registerUser: {
      success: 'User registered successfully, please wait for approval',
    },
  },
  errors: {
    consumer: {
      errorConsumerTable: 'Error getting consumption table data',
      errorConsumerChart: 'Error getting consumption chart data',
      errorUpdateConsumptions: 'Error updating consumptions',
      errorExportConsumptions: 'Error exporting consumptions',
    },
    masters: {
      errorGetMasters: 'Error getting masters data',
    },
    companyDetails: {
      errorGetCompanyDetails: 'Error getting company details',
      errorCreatePlant: 'Error creating plant',
      errorUpdatePlant: 'Error updating plant',
      errorDeletePlant: 'Error deleting plant',
      errorCreateCompanyUser: 'Error creating company user',
      errorUpdateCompanyUser: 'Error updating company user',
      errorDeleteCompanyUser: 'Error deleting company user',
    },
    moeveActions: {
      errorGetPendingActions: 'Error getting pending actions',
      errorChangeActionStatus: 'Error changing action status',
      errorGetActiveCompanies: 'Error getting active companies',
      errorChangeCompanyType: 'Error changing company type',
      errorDeleteCompany: 'Error deleting company',
    },
    auth: {
      errorGetCurrentUser: 'Error getting current user',
      errorRegisterUser: 'Error registering user',
    },
  },
  reportIssueModal: {
    title: 'Report an issue',
    message: 'If you need to report an issue, you can do so by sending an email to',
  },
};
